import ChatIndex from '../views/Chat/Index.vue'

const routes = {
  path: '/chat',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/chat',
      name: 'chat',
      component: ChatIndex,
      meta: {
        pageTitle: 'chat.title',
        access_nivel: ['1', '2', '3'],
        breadcrumb: [
          { text: 'chat.title', active: true },
        ],
      },
    },
  ],
}

export default routes
